module.exports = __webpack_public_path__ + "images/emoji/8ball.daa21ed623aef4257404.png";